export class OrganizationUpdateRequest {
    name: string;
    businessName: string;
    billingEmail: string;
}
